import { createStore } from "vuex";

export default createStore({
  state: {
    navs: [
      {
        name: "首页",
        to: "/home#banner",
      },
      {
        name: "产品中心",
        childWidth: "1.5rem",
        to: "/tags",
        Anchor: "/home#tags",
        child: [
          {
            name: "产品描述",
            to: "/tags",
            c: "tags",
          },
        ],
      },
      {
        name: "软件平台",
        childWidth: "1.64rem",
        to: "/software",
        // md: true,
        // 9
      },
      {
        name: "解决方案",
        childWidth: "1.64rem",
        to: "/plans?name=贴标管理",
        Anchor: "/home#fangAn",
        child: [
          {
            name: "方案",
            to: "/plans",
            c: "plans",
          },
        ],
      },
      {
        name: "新闻中心",
        childWidth: "2rem",
        to: "/tidings",
        Anchor: "/home#news",
      },
      {
        name: "关于我们",
        childWidth: "1.54rem",
        to: "/about",
        Anchor: "/home#about",
        // md: true,
        child: [
          {
            name: "关于公司",
            to: "/about",
            c: "about",
          },
        ],
      },
    ],
    headerColor: "black",
    headerTopBtnWhite: true,
  },
  mutations: {
    setHeaderColorBlack(state) {
      state.headerColor = "black";
    },
    setHeaderColorWhite(state) {
      state.headerColor = "white";
    },
    setheaderTopBtnWhite(state, d) {
      state.headerTopBtnWhite = d;
    },
    scrollToSection(state, id) {
      if (!id) return;
      id = id.slice(1);
      let section = document.getElementById(id);
      if (section) {
        section.scrollIntoView();
      }
    },
  },
  actions: {},
  getters: {
    navs: (state) => state.navs,
    headerColor: (state) => state.headerColor,
    headerTopBtnWhite: (state) => state.headerTopBtnWhite,
  },
  modules: {},
});
